import SuperAdminLayout from "SuperAdmin/SuperAdminLayout/SuperAdminLayout"
import SettingsNav from "SuperAdmin/SuperAdminNav/SettingsNav"



const RegistrationPageSettings = () =>{
    return<>
    <SuperAdminLayout>

        <SettingsNav />

        <h1> Registration Page Settings </h1>


    </SuperAdminLayout>
    
    </>
}
export default RegistrationPageSettings